import React, { Fragment } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Select from "../../../elements/CustomSelect";

const AddEditContractForm = ({
  handleSelectChange,
  handleContactChange,
  handleStoreChange,
  contractName,
  salesPersonId,
  storeId,
  salesPersonList,
  storeList,
  editPricingContract
}) => {
  return(
    <Fragment>
      <Row className="my-5">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Contract Name</Form.Label>
            <Form.Control type="input" onChange={handleContactChange} value={contractName} />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Select label={`Salesperson`} value={salesPersonId} handleChange={handleSelectChange} result={salesPersonList} ids="salesPersonId" validate={false} />
        </Col>
        <Col md={4}>
          <Select label={`Store`} value={storeId} handleChange={handleStoreChange} result={storeList} ids="storeId" validate={true} disabled={editPricingContract?.storeId} />
        </Col>
      </Row>
    </Fragment>
  )
}

export default AddEditContractForm;